export const getFirstImage = (apiData: string[] | null): string | null => {
    if (apiData === null || !(0 in apiData)) {
        return null;
    }

    return apiData[0];
};
